<button type="button" kb-icon [icon]="iconButton" (click)="open = !open" aria-hidden="true"></button>
<section kb-card class="content kb-scrollbar" kb-color-variant="secondary-variant">
  @if (attributes.headline) {
    <h3 slot="title" kb-heading type="bar">
      {{ attributes.headline }}
    </h3>
  }
  <div slot="content">
    @for (item of attributes.items; track item) {
      <h4 kb-heading>{{item.attributes.headline}}</h4>
      @if (item.attributes.copyText) {
        <kb-html  kb-html [html]="item.attributes.copyText" ></kb-html>
      }
    }
  </div>
</section>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
